/*
 * @Author: WGL
 * @Date: 2022-02-15 18:40:13
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-04-18 13:47:55
 * @Description: 
 */
export function setupComponents(app) {
  // 加载组件
  const Components = require.context('.', true, /\.vue$/)
  Components.keys()
    .map(Components)
    .forEach((item) => {
      // console.log(`item`, item)
      if (item?.default?.name) app.component(item.default.name, item.default)
    })
}
